import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import ConversationFlowEditor from './Editor.vue';
import ConversationFlowsIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/flowbuilder'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'conversation_flows_index',
          component: ConversationFlowsIndex,
          meta: {
            featureFlag: FEATURE_FLAGS.CONVERSATION_FLOWS,
            permissions: ['administrator'],
          },
        },
        {
          path: ':flowId',
          name: 'conversation_flow_editor',
          component: ConversationFlowEditor,
          meta: {
            featureFlag: FEATURE_FLAGS.CONVERSATION_FLOWS,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
